import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useResetRecoilState } from "recoil";
import { useGetActivitiesToday } from "../../hooks/useCrm";
import { crmActionCheckListAtom } from "../../shared/crm-action-checklist";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { TodayActions } from "../TodayActions/TodayActions";
import { TodayChances } from "../TodayChances/TodayChances";
import { TodayVisits } from "../TodayVisits/TodayVisits";
import { TabWrapper } from "./TodayActivitiesTabStyle";

export const TodayActivitiesTab = () => {
  const { data, isLoading } = useGetActivitiesToday();
  const actions = data?.data?.activity_crms;
  const users = data?.data?.user;
  const resetIds = useResetRecoilState(crmActionCheckListAtom);

  return (
    <TabWrapper>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        num3="فرصت ها و فعالیت های امروز"
        href1="/dashboard/crm"
        href2="/dashboard/crm/reporting"
      />
      <Tabs
        defaultActiveKey="actions"
        id="uncontrolled-tab-example"
        className="mb-3"
        onSelect={resetIds}
      >
        <Tab eventKey="actions" title="فعالیت های امروز">
          <TodayActions data={actions} isLoading={isLoading} users={users} />
        </Tab>
        <Tab eventKey="history" title="فرصت های امروز">
          <TodayChances data={actions} isLoading={isLoading} users={users} />
        </Tab>
        <Tab eventKey="invoice" title="ویزیت های امروز">
          <TodayVisits data={actions} isLoading={isLoading} users={users} />
        </Tab>
      </Tabs>
    </TabWrapper>
  );
};
